@if (modalVisible()) {
  <div class="modal">
    <div class="modal__overlay"
         (click)="closeModal()"
         (keydown.enter)="closeModal()"
         aria-hidden="true">
    </div>
    <dialog class="modal__content"
            open
            aria-modal="true"
            tabindex="-1"
            (keydown)="handleTabKey($event)">
      <ng-template #modalContent></ng-template>
    </dialog>
  </div>
}
